module.exports = __webpack_public_path__ + "img/1-leave reason.46bf20bc.jpg";